import type { ConversationState } from "../types";

export const initialConversationState: ConversationState = {
  conversationId: null,
  messages: [],
  loading: false,
  streaming: false,
  error: null,
  emailContext: null,
  draftReady: false,
  sources: [],
};
